<script>
export default {
  methods: {
    async getQuizResults(vid, uid) {
      let resultsUrl = '/jsonapi/quiz_result/quiz_result?sort=-time_start&filter[is_invalid]=0&filter[uid.meta.drupal_internal__target_id]=' + uid + '&filter[vid]=' + vid + '&include=uid'
      return fetch(resultsUrl)
        .then(res => {
          return res.json();
        })
        .then(json => {
          let res = json.data.map(el => {
            return {
              id:  el.attributes.drupal_internal__result_id,
              quiz_result_type: el.attributes.quiz_result_type,
              vid:  el.attributes.vid,
              time_start: el.attributes.time_start,
              time_end: el.attributes.time_end,
              released: el.attributes.released,
              score: el.attributes.score,
              is_invalid: el.attributes.is_invalid,
              is_evaluated: el.attributes.is_evaluated,
              attempt: el.attributes.attempt,
              created: el.attributes.created,
              changed: el.attributes.changed
            };
          });

          return res;
        });
    }
  }
}
</script>
